var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.999 4h12",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.332 4V2.667a1.333 1.333 0 011.333-1.334h2.667a1.333 1.333 0 011.333 1.334V4m2 0v9.333a1.333 1.333 0 01-1.333 1.334H4.665a1.333 1.333 0 01-1.333-1.334V4h9.333zM9.332 7.333v4M6.665 7.333v4",
    strokeLinecap: "round"
  }))));
}
export default __webpack_public_path__ + "media/icons/trash-icon-d78ab41b.svg";
export { SvgTrashIcon as ReactComponent };